var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLabviewOriginal = function SvgLabviewOriginal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M105.085 59.84a3.54 3.54 0 00-3.54 3.54v1.34a3.54 3.54 0 003.54 3.54h19.38a3.54 3.54 0 003.54-3.54v-1.34a3.54 3.54 0 00-3.54-3.54zM3.535 41.8a3.54 3.54 0 00-3.54 3.54v1.35a3.54 3.54 0 003.54 3.54h19.38a3.54 3.54 0 003.54-3.54v-1.35a3.54 3.54 0 00-3.54-3.54zM3.535 77.87a3.54 3.54 0 00-3.54 3.54v1.34a3.54 3.54 0 003.54 3.54h19.38a3.54 3.54 0 003.54-3.54v-1.34a3.54 3.54 0 00-3.54-3.54z",
    style: {
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000"
    },
    opacity: 0.998,
    fill: "#bec7cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.755 22.46c-4.42-.09-8.06 2.99-8.06 6.82v69.43c0 5.25 6.56 8.53 11.81 5.91l69.49-34.72c5.25-2.62 5.25-9.18 0-11.8l-69.49-34.72a8.856 8.856 0 00-3.75-.91z",
    style: {
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000"
    },
    opacity: 0.998,
    fill: "#ffd500"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.535 67.07h-11.95v11.99h-6.15V67.08h-11.95V61h11.95V49.02h6.15v11.99h11.95z",
    opacity: 0.998,
    fill: "#727b84"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLabviewOriginal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/labview-original.92da2583.svg";
export { ForwardRef as ReactComponent };